import React from 'react'
import {PriceFilter} from 'components/Filters/PriceFilter/PriceFilter'
import {FilterUrlParams} from 'modules/search/types'

export interface PriceFilterBottomSheetContentProps {
  priceMin: number
  priceMax: number
  toggleFilters: (updatedFilters: FilterUrlParams) => void
}

const PriceFilterBottomSheetContent = ({
  priceMin,
  priceMax,
  toggleFilters
}: PriceFilterBottomSheetContentProps) => (
  <PriceFilter
    priceMin={priceMin}
    priceMax={priceMax}
    onChange={toggleFilters}
  />
)

export default PriceFilterBottomSheetContent
